<template>
  <div class="collection-details">
    <page-header title="入账登记" icon="el-icon-money" />
    
    <!-- 搜索表单 -->
    <el-card class="search-card">
      <div class="card-title">
        <i class="el-icon-search"></i>
        <span>筛选查询</span>
      </div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="登记日期">
          <el-date-picker
            v-model="searchForm.dateRange""
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="date-range-picker"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item label="审批单号">
          <el-input v-model="searchForm.approvalNo" placeholder="请输入审批单号" class="filter-item"  clearable/>
        </el-form-item>
        <!-- <el-form-item label="入账项目">
          <el-select v-model="searchForm.project" placeholder="请选择" class="filter-item">
            <el-option 
              v-for="item in projectList" 
              :key="item.itemValue"
              :label="item.itemLabel" 
              :value="item.itemValue"
            />
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="收款账户">
          <el-select v-model="searchForm.paymentMethod" placeholder="请选择" class="filter-item">
            <el-option 
              v-for="item in paymentMethodList" 
              :key="item.itemValue"
              :label="item.itemLabel" 
              :value="item.itemValue"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="交易单号">
          <el-input 
            v-model="searchForm.transactionNo" 
            placeholder="请输入交易单号" 
            class="filter-item transaction-no-input"
            clearable 
          />
        </el-form-item>
        <el-form-item label="审核状态" class="status-select">
          <el-select v-model="searchForm.auditStatus" placeholder="请选择" class="filter-item">
            <el-option 
              v-for="item in auditStatusList" 
              :key="item.value" 
              :label="item.label" 
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="交易时间">
          <el-date-picker
            v-model="searchForm.transactionTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="date-range-picker"
            :picker-options="pickerOptions"
          />
        </el-form-item>

    
      
        <el-form-item class="filter-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <!-- <el-button type="success" icon="el-icon-download" @click="handleExport">导出</el-button> -->
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>  
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 修改表格为卡片列表 -->
    <el-card class="list-card">
      <div class="operation-bar">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">入账登记</el-button>
      </div>

      <div v-loading="loading" class="audit-list">
        <!-- 使用 v-for 循环渲染每条数据 -->
        <el-card v-for="item in tableData" :key="item.id" class="audit-item">
          <el-row :gutter="20">
            <!-- 左侧图片区域 -->
            <el-col :span="6">
              <div class="image-container">
                <el-image
                  v-if="item.voucherFileName"
                  style="width: 100%; height: 300px"
                  :src="'/api/api/v1/static/' + item.voucherFileName"
                  :preview-src-list="['/api/api/v1/static/' + item.voucherFileName]"
                  fit="contain"
                />
                <div v-else class="no-image">暂无图片</div>
              </div>
            </el-col>

            <!-- 右侧信息区域 -->
            <el-col :span="18">
              <div class="info-container">
                <div class="info-header">
                  <h3>登记信息栏</h3>
                  <el-tag :type="getAuditStatusType(item.auditStatus)">
                    审核状态：{{ getAuditStatusText(item.auditStatus)}}
                  </el-tag>
                 
                </div>

                <el-row :gutter="20" class="info-content">
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">登记日期：</span>
                      <span class="value">{{ item.registerDate }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">登记人：</span>
                      <span class="value">{{ item.registrant }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">代理商名称：</span>
                      <span class="value">{{ item.agentName }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">审批单号：</span>
                      <span class="value">{{ item.approvalNo }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">入账项目：</span>
                      <span class="value">{{ item.project }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">收款账户：</span>
                      <span class="value">{{ item.paymentMethod }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">交易时间：</span>
                      <span class="value">{{ item.transactionTime }}</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">应收金额：</span>
                      <span class="value">{{ item.receivableAmount }} 元</span>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <span class="label">实收金额：</span>
                      <span class="value">{{ item.actualAmount }} 元</span>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="info-item">
                      <span class="label">交易单号：</span>
                      <span class="value">{{ item.transactionNo }}</span>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="info-item">
                      <span class="label">备注：</span>
                      <span class="value">{{ item.remark }}</span>
                    </div>
                  </el-col>
                 </el-row>
                 <el-row :gutter="20" class="info-content">
                  <el-col :span="24">
                    <el-tag 
                    type="danger"
                    v-if="item.auditStatus === -1 || item.auditStatus === -2 || item.auditStatus === -3"
                    class="reject-reason"
                  >
                    拒绝原因：{{ item.auditStatus === -1 ? item.supervisor_audit_remark : item.auditStatus === -2 ? item.finance_audit_remark : item.manager_audit_remark }}
                  </el-tag>
                  </el-col>
                 </el-row>

                <div class="info-footer">
                  <div class="actions">
                    <el-button 
                      type="text" 
                      size="small" 
                      class="edit-btn"
                      @click="handleEdit(item)"
                      v-if="item.auditStatus === 0 || item.auditStatus === -1 || item.auditStatus === -2 || item.auditStatus === -3"
                    >
                      编辑
                    </el-button>
                    <el-button 
                      v-if="item.auditStatus === 0"
                      type="primary" 
                      size="small" 
                      @click="handleSubmitAudit(item)"
                    >
                      提交审核
                    </el-button>
                    <el-button 
                      v-if="item.auditStatus !== AUDIT_STATUS.COMPLETED"
                      type="danger" 
                      size="small" 
                      class="withdraw-btn"
                      @click="handleWithdraw(item)"
                    >
                      <i class="el-icon-back"></i>
                      撤回
                    </el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>

      <!-- 在分页组件前添加金额统计 -->
      <div class="pagination-container">
        <div class="amount-summary">
          <span class="summary-item">
            应收总金额：<span class="amount">{{ totalReceivable }}</span> 元
          </span>
          <span class="summary-item">
            实收总金额：<span class="amount">{{ totalActual }}</span> 元
          </span>
        </div>
       
        <el-pagination
          :current-page="page.current"
          :page-sizes="[5, 10, 20, 30]"
          :page-size="page.size"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <!-- 错误提示 -->
      <el-alert
        v-if="errorMessage"
        title="保存失败"
        type="error"
        :description="errorMessage"
        show-icon
        :closable="true"
        class="save-error-alert"
        style="margin-bottom: 20px;"
      />

      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="140px"
        class="two-column-form"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="ICCID" prop="iccid">
              <el-input 
                v-model="form.iccid" 
                placeholder="请输入ICCID查询代理商"
                @blur="handleIccidBlur"
                @keyup.enter.native="handleIccidBlur"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理商名称" prop="agentName">
              <el-input v-model="form.agentName" placeholder="请输入代理商名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批单号" prop="approvalNo">
              <el-input v-model="form.approvalNo" placeholder="请输入卡板及设备出库审批流程单号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入账项目" prop="project">
              <el-select 
                v-model="form.project" 
                placeholder="请选择项目" 
                style="width: 100%"
                filterable
              >
                <el-option 
                  v-for="item in projectList" 
                  :key="item.itemValue"
                  :label="item.itemLabel" 
                  :value="item.itemValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="转账截图" prop="form.VoucherFileName">
              <el-upload
                class="upload-demo"
                action="/api/api/v1/upload/file"
                :headers="uploadHeaders"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :before-upload="beforeUpload"
                :on-remove="handleRemove"
                :file-list="fileList"
                :limit="1"
                :drag="true"
                list-type="picture-card"
                :auto-upload="true"
                :on-change="handleChange"
              >
                <i class="el-icon-plus"></i>
                <div class="upload-tip">只能上传jpg/png格式图片，且不超过2MB</div>
              </el-upload>
             
              <el-button 
                type="primary" 
                size="small" 
                @click="handleReIdentify" 
                :disabled="!form.VoucherFileName"
                class="re-identify-btn"
              >
                重新识别
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交易订单号" prop="transactionNo">
              <el-input v-model="form.transactionNo" placeholder="请上传凭证识别" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交易时间" prop="transactionTime">
              <el-date-picker
                v-model="form.transactionTime"
                type="datetime"
                placeholder="选择交易时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收款账户" prop="paymentMethod">
              <el-select v-model="form.paymentMethod" placeholder="请选择收款账户" style="width: 100%">
                <el-option v-for="item in paymentMethodList" 
                  :key="item.itemValue"
                  :label="item.itemLabel" 
                  :value="item.itemValue"
                />
              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="实收金额" prop="actualAmount">
              <el-input-number
                v-model="form.actualAmount"
                :precision="2"
                :step="100"
                :min="0"
                style="width: 100%"
                controls-position="right"
                placeholder="请输入实收金额"
               
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应收金额" prop="receivableAmount">
              <el-input-number
                v-model="form.receivableAmount"
                :precision="2"
                :step="100"
                :min="0"
                style="width: 100%"
                controls-position="right"
                placeholder="请输入应收金额"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="form.remark"
                type="textarea"
                :rows="3"
                placeholder="请输入备注信息"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 识别加载对话框 -->
    <el-dialog
      title="识别中"
      :visible.sync="ocrLoading"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="300px"
      center
      class="ocr-loading-dialog"
    >
      <div class="ocr-loading-content">
        <el-progress type="circle" :percentage="timePercentage"></el-progress>
        <div class="countdown-text">剩余 {{ countdown }} 秒</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import PageHeader from '@/components/PageHeader.vue'
import { getDictData } from '@/api/dict'
import moment from 'moment'

export default {
  name: 'CollectionDetails',
  components: {
    PageHeader
  },
  data() {
    // 获取当前日期和7天前的日期
    const now = new Date()
    const lastWeek = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
    
    // 格式化日期
    this.formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    return {
      totalReceivable: 0, // 应收总金额
      totalActual: 0, // 实收总金额
      // 搜索表单
      searchForm: {
        dateRange: [
          `${this.formatDate(lastWeek)} 00:00:00`,  // 7天前的日期 00:00:00
          `${this.formatDate(now)} 23:59:59`  // 今天 23:59:59
        ],
        stime: '',
        etime: '',
        cardNo: '',
     
        approvalNo: '',
        project: '',
        paymentMethod: '',
        paymentMethod: '',
        transactionNo: '',
        transactionTimeRange: null,
        auditStatus: '0',
       

      },
      // 表格数据
      tableData: [],
      loading: false,
      // 分页
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      // 对话框
      dialogVisible: false,
      dialogTitle: '入账登记',
      // 表单
      form: {
        iccid: '',
        agentName: '',
        approvalNo: '',
        transactionNo: '',
        transactionTime: '',
        project: '',
        paymentMethod: '',
        receivableAmount: 0,
        actualAmount: 0,
        VoucherFileName: '',
        remark: '',
        list: [],
        supervisor_audit_remark: '',
        finance_audit_remark: '',
        manager_audit_remark: '',
      },
      paymentMethodList: [],
      projectList: [],
      fileList: [],//上传的文件列表
      // 添加表单验证规则
      rules: {
        agentName: [
          { required: true, message: '请输入代理商名称', trigger: 'blur' }
        ],
        // approvalNo: [
        //   { required: true, message: '请输入审批单号', trigger: 'blur' }
        // ],
        project: [
          { required: true, message: '请选择入账项目', trigger: 'change' }
        ],
       uploadedFileName: [
          { required: true, message: '请上传转账截图', trigger: 'change' }
        ]
      },
     
      uploadHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      ocrLoading: false, // 识别加载状态
      countdown: 60, // 倒计时秒数
      timePercentage: 100, // 进度条百分比
      timer: null, // 定时器
      uploadedFileName: '', // 添加这个变量保存上传的文件名
      // 添加审核状态选项
      auditStatusList: [
        { value: '0', label: '全部' },
        { value: '1', label: '草稿  ' },
        { value: '2', label: '审批中' },
        { value: '3', label: '完成' },
        { value: '4', label: '驳回' }
        
      ],
      // 修改日期选择器配置
      pickerOptions: {
        firstDayOfWeek: 1,  // 设置周一为一周的第一天
        
         

      },
      errorMessage: '',  // 添加错误信息字段
      AUDIT_STATUS: {
        DRAFT: 0,        // 草稿
        SUBMITTED: 1,    // 已提交
        PROCESSING: 2,   // 处理中
        REJECTED: 3,     // 已驳回
        COMPLETED: 4     // 完成
      }
    }
  },
  created() {
    this.handleSearch()
    this.loadConfig()
  },
  methods: {
    // 格式化金额
    formatAmount(amount) {
      return amount.toLocaleString('zh-CN',{
       minimumFractionDights:2,
       maximumFractionDights:2
      } )
    },
    handleExceed() {
      this.$message.warning('只能上传一张图片')
    },
    handleRemove() {
      this.form.VoucherFileName = '';
      this.fileList = [];
      // 清空表单数据
      this.clearFormData();
    },
    // 修改 loadConfig 方法，增加获取收款账户数据
    async loadConfig() {
      try {
        // 获取入账项目数据
        const projectData = await this.getDictData("KFRZXM")
        if (projectData && projectData.length > 0) {
          this.projectList = projectData
        } else {
          console.error('获取入账项目数据为空')
        }

        // 获取收款账户数据
        const paymentData = await this.getDictData("KFSKZH")
        if (paymentData && paymentData.length > 0) {
          this.paymentMethodList = paymentData
        } else {
          console.error('获取收款账户数据为空')
        }
      } catch (error) {
        console.error('获取字典数据失败:', error)
        this.$message.error('获取字典数据失败')
      }
    },

    // getDictData 方法保持不变
    async getDictData(_type) {
      const response = await getDictData(_type)
      if (response.status === 1) {
        return response.data
      }
      return []
    },

    // 获取表格数据
    async fetchData(params) {
      this.loading = true
      try {
        const response = await request({
          url: '/api/v1/kf-account-money/list',
          method: 'POST',
          data: params
        })
        

        // 处理返回的数据
        if (response.data) {
          this.totalReceivable = response.totalReceivable
          this.totalActual = response.totalActual
          this.tableData = response.data.map(item => ({
            id: item.id,//id
            registerDate: item.entry_time ? item.entry_time.split('T')[0] : '',//登记时间
            registrant: item.entry_person_name,//登记人
            department: item.entry_dept_name,//登记部门
            orderCompleteTime: item.approval_finish_time ? item.approval_finish_time.replace('T', ' ').split('+')[0] : '',//审批完成时间
            approvalNo: item.approval_form_no,//审批单号
            transactionNo: item.transaction_order_no,//交易订单号
            project: item.entry_project_name,//入账项目
            projectCode: item.entry_project_id,//入账项目编码
            paymentMethod: item.receivable_account_name,//收款账户
            paymentMethodCode: item.receivable_account_code,//收款账户编码
            receivableAmount: item.receivable_amount,//应收金额
            actualAmount: item.actual_amount,//实收金额
            auditStatus: item.entry_audit_status,//审核状态
            agentName: item.agent_level,//代理商名称
            remark: item.transaction_remark,//备注
            transactionTime: item.transaction_time ? item.transaction_time.replace('T', ' ').split('+')[0] : '',//交易时间
            voucherFileName: item.voucher_file_name,
            supervisor_audit_remark: item.supervisor_audit_remark,
            finance_audit_remark: item.finance_audit_remark,
            manager_audit_remark: item.manager_audit_remark,
          }))


          // console.log(this.tableData)
        
          // 更新总条数
          
        }
        this.page.total = response.total || 0
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      }
      this.loading = false
    },

    // 搜索
    handleSearch() {
     this.handleResetPage()
     this.handleSearchWithParams()
    },
    
    // 重置
    handleReset() {
      const now = new Date()
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      
      this.searchForm = {
        dateRange: [
         `${this.formatDate(firstDay)} 00:00:00`,  // 月初 00:00:00
          `${this.formatDate(lastDay)} 23:59:59`     // 月末 23:59:59
        ],
        approvalNo: '',
        project: '',
        paymentMethod: '',
        transactionNo: '',
        transactionTimeRange: null,  // 改为 null 而不是空数组
        auditStatus: ''
      }

      this.handleResetPage()
      this.handleSearchWithParams()
    },

    // 新增
    handleAdd() {
      this.errorMessage = ''  // 清除错误信息
      this.dialogTitle = '新增入账登记'
      this.dialogVisible = true
      this.form = {
        iccid: '',
        agentName: '',
        approvalNo: '',
        transactionNo: '',
        transactionTime: '',
        project: '',
        paymentMethod: '',
        receivableAmount: 0,
        actualAmount: 0,
        VoucherFileName: '',
        remark: ''
      }
      this.fileList = []
    },

    // 编辑
    handleEdit(row) {
      this.errorMessage = ''  // 清除错误信息
      this.dialogTitle = '编辑入账登记'
      this.dialogVisible = true

      this.form = {
        id: row.id,
        iccid: row.iccid,
        agentName: row.agentName,
        approvalNo: row.approvalNo,
        transactionNo: row.transactionNo,
        project: row.projectCode,
        transactionTime: row.transactionTime,
        paymentMethod: row.paymentMethodCode,
        receivableAmount: row.receivableAmount,
        actualAmount: row.actualAmount,
        VoucherFileName: row.voucherFileName,
        

        // receivable_account_code: row.receivable_account_code,
        // receivable_account_name: row.receivable_account_name,

        

        remark: row.remark
      }


      
      // 如果有转账截图，设置文件列表
      if (row.VoucherFileName) {
        this.fileList = [{
          name: '转账截图',
          url: row.VoucherFileName
        }]
      } else {
        this.fileList = []
      }
    },

  

    // 提交表单
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        
        const response = await request({
          url: '/api/v1/kf-account-money/save',
          method: 'POST',
          data: {
            id: this.form.id,
            approval_form_no: this.form.approvalNo,
            entry_project_id: this.form.project,
            voucher_file_name: this.form.VoucherFileName,
            receivable_amount: this.form.receivableAmount,
            actual_amount: this.form.actualAmount,
            payment_remarks: this.form.remark,
            transaction_order_no: this.form.transactionNo,
            transaction_time: this.form.transactionTime,
            account_name: this.form.paymentMethod,
            agent_name: this.form.agentName
          }
        })

        if (response.status === 1) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.handleSearchWithParams()
        } else {
          this.errorMessage = response.error  // 设置错误信息
          console.error('保存失败原因:', response)
        }
      } catch (error) {
        this.errorMessage = error.response?.data?.msg || error.msg || '保存失败，请检查输入信息'
        console.error('保存失败详细信息:', error.response?.data || error)
        console.error('保存失败:', error)
      }
    },

    // 分页
    handleSizeChange(val) {
      this.page.size = val
      this.handleResetPage()
      this.handleSearchWithParams()
    },
    //重置页码
    handleResetPage() {
      this.page.current = 1
      //重置总金额
      this.totalReceivable = 0
      this.totalActual = 0
    },
    //带参数查询
    handleSearchWithParams() {


       

       // 构建分页参数，包含所有搜索条件
       const params = {
        page: this.page.current,
        size: this.page.size,
        entry_time_start: this.searchForm.dateRange ? moment(this.searchForm.dateRange[0]).format('YYYY-MM-DD 00:00:00') : '',
        entry_time_end: this.searchForm.dateRange ? moment(this.searchForm.dateRange[1]).format('YYYY-MM-DD 23:59:59') : '',
        approval_form_no: this.searchForm.approvalNo,
        transaction_order_no: this.searchForm.transactionNo,
        transaction_time_start: this.searchForm.transactionTimeRange ? moment(this.searchForm.transactionTimeRange[0]).format('YYYY-MM-DD 00:00:00') : '',
        transaction_time_end: this.searchForm.transactionTimeRange ? moment(this.searchForm.transactionTimeRange[1]).format('YYYY-MM-DD 23:59:59') : '',
        entry_audit_status: this.searchForm.auditStatus !== '' ? parseInt(this.searchForm.auditStatus) : ''
      }

      console.log(params)
      
      // // 移除空值
      // Object.keys(params).forEach(key => {
      //   if (params[key] === '' || params[key] === null || params[key] === undefined) {
      //     delete params[key]
      //   }
      // })
      
      this.fetchData(params)
    },
    handleCurrentChange(val) {
      this.page.current = val
      // 构建分页参数，包含所有搜索条件
      this.handleSearchWithParams()
    },

    // 修改上传成功的处理方法
    async handleUploadSuccess(response, file) {
      if (response.status === 1) {
        // 设置新的文件
        this.fileList = [file];
        this.form.VoucherFileName = response.data.filename;

        // 开始识别过程
        await this.startOcrRecognition();
      } else {
        this.$message.error('图片上传失败');
        this.fileList = [];
        this.form.VoucherFileName = '';
      }
    },
    
    handleUploadError(err) {
      console.error('上传失败:', err)
      this.$message.error('上传失败，请重试')
    },
    beforeUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPGOrPNG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },

    // 新增识别过程方法
    async startOcrRecognition() {
      if (!this.form.VoucherFileName) {
        return;
      }

      // 开始倒计时
      this.ocrLoading = true;
      this.countdown = 60;
      this.timePercentage = 100;
      
      this.timer = setInterval(() => {
        this.countdown--;
        this.timePercentage = Math.round(((60 - this.countdown) / 60) * 100);
        
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.ocrLoading = false;
          this.$message.warning('识别超时，请手动填写信息或点击重新识别');
        }
      }, 1000);

      try {
        const ocrResponse = await request({
          url: '/api/v1/kf-work-order/ocr',
          method: 'POST',
          timeout: 100000,
          data: {
            image: this.form.VoucherFileName
          }
        });

        // 清除倒计时
        clearInterval(this.timer);
        this.ocrLoading = false;

        if (ocrResponse.status === 1) {
          // 识别成功，填充表单数据
          const ocrData = ocrResponse.data;
          
          if (ocrData.kind) {
            this.form.paymentMethod = ocrData.kind;
          }
          if (ocrData.money) {
            this.form.actualAmount = parseFloat(ocrData.money);
            this.form.receivableAmount = parseFloat(ocrData.money);
          }
          if (ocrData.time) {
            this.form.transactionTime = ocrData.time;
          }
          if (ocrData.order_id) {
            this.form.transactionNo = ocrData.order_id;
          }

          this.$message.success('识别成功');
        } else {
          this.$message.error('识别失败，请重试');
        }
      } catch (error) {
        clearInterval(this.timer);
        this.ocrLoading = false;
        console.error('OCR识别出错:', error);
        this.$message.error('识别失败，请重试');
      }
    },

    // 修改重新识别方法
    handleReIdentify() {
      this.startOcrRecognition();
    },

    // 添加清空表单数据的方法
    clearFormData() {
      // 清空相关字段
      this.form.paymentMethod = '';  // 收款账户
      this.form.actualAmount = 0;    // 实收金额
      this.form.receivableAmount = 0; // 应收金额
      this.form.transactionTime = ''; // 交易时间
      this.form.transactionNo = '';   // 交易订单号
    },

    // 修改 ICCID 失焦处理方法
    async handleIccidBlur() {
      if (!this.form.iccid) {
        return;
      }

      try {
        const response = await request({
          url: '/api/v1/kf-work-order/ocr/card-info',
          method: 'POST',
          data: {
            iccid: this.form.iccid
          }
        });

        if (response.status === 1) {
          // 自动填充代理商名称
          this.form.agentName = response.agent;
          // 清除该字段的验证错误
          this.$refs.form.clearValidate('agentName');
          
        } else {
          this.$message.warning('未找到对应的代理商信息');
        }
      } catch (error) {
        console.error('获取代理商信息失败:', error);
        this.$message.error('获取代理商信息失败');
      }
    },

    // 修改提交审核方法
    async handleSubmitAudit(row) {
      try {
        await this.$confirm('确认提交审核?', '提示', {
          type: 'warning'
        })

        const response = await request({
          url: '/api/v1/kf-account-money/submit',
          method: 'POST',
          data: {
            id: row.id
          }
        })

        if (response.status === 1) {
          this.$message.success(response.msg || '提交审核成功')
          this.handleSearchWithParams()
        } else {
          this.$message.error(response.error)
          console.error('提交审核失败原因:', response)
        }
      } catch (error) {
        console.error('提交审核失败:', error)
        this.$message.error(error.response?.data?.msg || error.msg || '提交审核失败，请稍后重试')
      }
    },

    // 获取审核状态类型
    getAuditStatusType(status) {
      switch (status) {
        case 0:
          return 'info'
        case 1:
          return 'warning'
        case 2:
          return 'warning'
        case 3:
          return 'warning'
        case 4:
          return 'success'
        case -1:
          return 'danger'
        case -2:
          return 'danger'
        case -3:
          return 'danger'
        default:
          return 'info'
      }
    },

    // 获取审核状态文本
    getAuditStatusText(status) {
      switch (status) {
        case 0:
          return '草稿'
        case 1:
          return '主管审批中'
        case 2:
          return '财务审批中'
        case 3:
          return '经理审批中'
        case 4:
          return '完成'
        case -1:
          return '主管拒绝'
        case -2:
          return '财务拒绝'
        case -3:
          return '经理拒绝'
        default:
          return '未知状态'
      }
    },
    // 添加单元格样式方法
    cellStyle() {
      return {
        textAlign: 'center',
        padding: '8px 0'
      }
    },
    // 添加表头样式方法
    headerCellStyle() {
      return {
        textAlign: 'center',
        backgroundColor: '#F5F7FA',
        color: '#606266',
        fontWeight: 'bold',
        padding: '12px 0'
      }
    },
    // 添加 handleChange 方法
    handleChange(file, fileList) {
      // 如果已经有文件，先清空旧数据和文件
      if (this.fileList.length > 0) {
        this.clearFormData();
        this.fileList = [];
        //this.form.VoucherFileName = '';
      }
    },
    // 添加导出方法
    async handleExport() {
        try {
            // 构造导出参数，与搜索参数保持一致
            const params = {
                entry_time_start: this.searchForm.dateRange?.[0],
                entry_time_end: this.searchForm.dateRange?.[1],
                transaction_time_start: this.searchForm.transactionTimeRange?.[0],
                transaction_time_end: this.searchForm.transactionTimeRange?.[1],
                approval_form_no: this.searchForm.approvalNo,
                entry_project_id: this.searchForm.project,
                receivable_account_code: this.searchForm.paymentMethod,
                transaction_order_no: this.searchForm.transactionNo,
                entry_audit_status: this.searchForm.auditStatus
            }

            // 发起导出请求
            const response = await request({
                url: '/api/v1/kf-account-money/export',
                method: 'POST',
                data: params,
                responseType: 'blob'  // 指定响应类型为blob
            })

            // 创建下载链接
            const blob = new Blob([response], { type: 'application/vnd.ms-excel' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            
            // 生成文件名，使用当前时间戳
            const fileName = `入账登记数据_${new Date().getTime()}.xlsx`
            link.download = fileName
            
            // 触发下载
            link.click()
            
            // 清理
            window.URL.revokeObjectURL(link.href)
            
            this.$message.success('导出成功')
        } catch (error) {
            console.error('导出失败:', error)
            this.$message.error('导出失败，请重试')
        }
    },
    handleDialogClose() {
      this.$refs.form.resetFields()
      this.errorMessage = ''
    },
    // 添加格式化日期的方法
    formatDateWithTime(date, isEndTime = false) {
      const baseDate = this.formatDate(date)
      return isEndTime ? `${baseDate} 23:59:59` : `${baseDate} 00:00:00`
    },
    // 修改撤回操作的处理方法
    handleWithdraw(item) {
      this.$confirm('如果撤回数据将无法恢复,请谨慎!', '确认撤回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await request({
            url: '/api/v1/kf-account-money/revoke',
            method: 'POST',
            data: {
              id: item.id
            }
          })
          
          if (response.status === 1) {
            this.$message.success('撤回成功')
          // 重新获取数据
            this.handleSearchWithParams()
          } else {
            this.$message.error(response.message || '撤回失败')
          }
        } catch (error) {
          console.error('撤回失败:', error)
          this.$message.error('撤回失败')
        }
      }).catch(() => {
        // 取消撤回操作
      })
    }
  },
  computed: {
    // 计算应收总金额
    totalReceivable() {
      return this.tableData.reduce((sum, item) => {
        return sum + (parseFloat(item.receivableAmount) || 0)
      }, 0).toFixed(2)
    },
    // 计算实收总金额
    totalActual() {
      return this.tableData.reduce((sum, item) => {
        return sum + (parseFloat(item.actualAmount) || 0)
      }, 0).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.demo-form-inline {
    .el-form-item {
        margin-right: 20px;
        margin-bottom: 18px;
        
        .date-range-picker {
            width: 360px;
        }
        
        .filter-item {
            width: 200px;
        }
    }
    
    .filter-buttons {
        margin-bottom: 0;
        
        .el-button {
            margin-left: 0;
            margin-right: 10px;
            
            &:last-child {
                margin-right: 0;
            }
        }
    }
}

.collection-details {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.card-title {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}

.card-title i {
  margin-right: 5px;
}

.filter-item {
  width: 220px;
}

.filter-buttons {
  margin-left: 10px;
}

.operation-bar {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.el-input-number {
  width: 100%;
}

.el-dialog {
  max-width: 90%;
}

.el-form-item {
  margin-bottom: 18px;
}

.el-form {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 10px;
}

.two-column-form {
  padding: 20px;
}

.two-column-form .el-form-item {
  margin-bottom: 22px;
}

/* 调整弹框样式 */
:deep(.el-dialog) {
  min-width: 900px;
}

:deep(.el-dialog__body) {
  padding: 10px 20px;
}

/* 美化滚动条 */
.el-form::-webkit-scrollbar {
  width: 6px;
}

.el-form::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

.el-form::-webkit-scrollbar-track {
  background: #f5f7fa;
}

/* 确保所有输入框宽度一致 */
.el-input,
.el-select,
.el-date-picker,
.el-input-number {
  width: 100% !important;
}

/* 文本域占满整行 */
.el-col-24 .el-textarea {
  width: 100%;
}

/* 调整上传组件尺寸 */
:deep(.el-upload--picture-card) {
  width: 50px !important;
  height: 50px !important;
  line-height: 50px !important;
}

:deep(.el-upload-dragger) {
  width: 50px !important;
  height: 50px !important;
  padding: 0 !important;
}

:deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 50px !important;
  height: 50px !important;
}

/* 调整上传图标大小 */
:deep(.el-icon-plus) {
  font-size: 16px;
}

/* 隐藏拖拽提示文字 */
:deep(.el-upload__text) {
  display: none;
}

/* 调整预览图片容器大小 */
:deep(.el-upload-list--picture-card) {
  display: inline-flex;
  gap: 8px;
}

/* 调整整个上传区域的布局 */
.upload-demo {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 上传提示文字样式 */
.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

/* 添加金额输入框组样式 */
.amount-group {
  display: flex;
  gap: 20px;
}

.amount-item {
  flex: 1;
  margin-bottom: 0;
}

/* 调整金额输入框标签宽度 */
.amount-item :deep(.el-form-item__label) {
  width: 70px !important;
}

/* 确保输入框填满剩余空间 */
.amount-item :deep(.el-form-item__content) {
  margin-left: 70px !important;
}

/* 识别加载对话框样式 */
.ocr-loading-dialog {
  :deep(.el-dialog__header) {
    padding: 15px;
    text-align: center;
  }
  
  :deep(.el-dialog__body) {
    padding: 20px;
  }
}

.ocr-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.countdown-text {
  font-size: 14px;
  color: #606266;
}

/* 重新识别按钮样式 */
.re-identify-btn {
  margin-top: 8px;
  width: 100%;  /* 让按钮宽度与上传区域一致 */
}

/* 添加或修改样式 */
.date-range-picker {
  width: 380px !important;  /* 增加日期选择器宽度 */
}

.amount-summary {
  float: left;
  margin-top: 20px;
  font-size: 14px;
}

.summary-item {
  margin-right: 30px;
}

.summary-item .amount {
  color: #f56c6c;
  font-weight: bold;
  font-size: 16px;
}

/* 添加表格相关样式 */
.el-table {
  margin-top: 10px;
}

/* 调整表格内容字体大小 */
:deep(.el-table) {
  font-size: 14px;
}

/* 调整金额列的样式 */
:deep(.el-table .amount-column) {
  font-family: Monaco, monospace;
  color: #606266;
}

/* 调整状态标签的样式 */
:deep(.el-tag) {
  margin: 0 auto;
  display: inline-block;
}

/* 调整操作按钮的样式 */
:deep(.el-table .operation-column) {
  .el-button {
    padding: 4px 8px;
  }
}

/* 添加代理商名称的样式 */
.agent-name {
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 4px;
}

.agent-name:hover {
  background-color: #f5f7fa;
}

/* 自定义 tooltip 内容样式 */
.tooltip-content {
  font-size: 12px;
  line-height: 1.8;
}

/* 修改 tooltip 样式 */
:deep(.el-tooltip__popper) {
  max-width: 300px;
  padding: 10px 12px;
  line-height: 1.4;
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.8) !important;
}

:deep(.el-tooltip__popper[x-placement^="top"] .popper__arrow::after) {
  border-top-color: rgba(0, 0, 0, 0.8) !important;
}

/* 优化标签样式 */
.el-tag {
  cursor: default;
}

/* 复用财务审核页面的样式 */
.audit-list {
  margin: 20px 0;
}

.audit-item {
  margin-bottom: 20px;
}

.image-container {
  background-color: #f5f7fa;
  border-radius: 4px;

}

.no-image {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}

.info-container {
  padding: 0 20px;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.info-header h3 {
  margin: 0;
  font-size: 16px;
  color: #303133;
}

.info-content {
  margin-bottom: 20px;
}

.info-item {
  margin-bottom: 15px;
}

.info-item .label {
  color: #606266;
  margin-right: 8px;
}

.info-item .value {
  color: #303133;
  font-weight: 500;
}

.info-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.actions {
  margin-left: auto;
}

.actions .el-button {
  margin-left: 10px;
}

.warning-icon {
  color: #E6A23C;
  margin-left: 5px;
  cursor: help;
}

.save-error-alert {
  margin-top: 15px;
  margin-bottom: -10px;
  
  :deep(.el-alert__title) {
    font-size: 14px;
    font-weight: bold;
  }
  
  :deep(.el-alert__description) {
    margin: 8px 0;
    color: #F56C6C;
    font-size: 13px;
  }
}

.reject-reason {
  margin-left: 10px;
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
}

.edit-btn {
  font-size: 16px !important;  /* 增加字体大小 */
  font-weight: 500;  /* 稍微加粗 */
  padding: 0 15px;  /* 增加内边距 */
  height: 32px;  /* 增加按钮高度 */
  line-height: 32px;  /* 调整行高以垂直居中 */
}

/* 调整交易单号输入框宽度 */
.transaction-no-input {
  width: 300px !important;  /* 减小宽度以适应数字长度 */
}

/* 调整审核状态选择器的样式 */
.status-select {
  margin-left: 0 !important;  /* 减少左边距 */
  display: inline-block !important;  /* 确保在同一行 */
}

/* 确保表单项在同一行 */
.el-form-item {
  margin-right: 10px;  /* 调整表单项之间的间距 */
  display: inline-block;
}

/* 添加金额统计样式 */
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.amount-summary {
  display: flex;
  gap: 20px;
}

.summary-item {
  font-size: 14px;
  color: #606266;
}

.amount {
  font-size: 16px;
  font-weight: bold;
  color: #F56C6C;  /* 红色数字 */
  margin: 0 4px;
}

/* 调整按钮样式 */
.actions .el-button {
  margin-left: 10px;
}

/* 撤回按钮样式 */
.actions .el-button--danger {
  background-color: #fff;
  border-color: #F56C6C;
  color: #F56C6C;
}

.actions .el-button--danger:hover {
  background-color: #F56C6C;
  border-color: #F56C6C;
  color: #fff;
}

/* 撤回按钮样式 */
.withdraw-btn {
  background: linear-gradient(to right, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%);
  border: none;
  color: #fff;
  font-weight: 500;
  padding: 8px 15px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.withdraw-btn:hover {
  background: linear-gradient(to right, #ff7e82 0%, #f8c1b3 99%, #f8c1b3 100%);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(255, 154, 158, 0.3);
}

.withdraw-btn:active {
  transform: translateY(0);
  box-shadow: none;
}

.withdraw-btn i {
  margin-right: 4px;
  font-size: 14px;
}
</style> 